import { Results } from './pagination'

export const CREATED = 'OP_CREATED'
export const STARTED = 'OP_STARTED'
export const RUNNING = 'OP_RUNNING'
export const DONE = 'OP_DONE'
export const ABORTED = 'OP_ABORTED'
export const FAILED = 'OP_FAILED'

export type OptimizationProcessStatus =
  | typeof CREATED
  | typeof STARTED
  | typeof RUNNING
  | typeof DONE
  | typeof ABORTED
  | typeof FAILED

export type PipelineType = 'from_empty' | 'from_last_config'

export type OptimizationProcess = {
  id: number
  dataIngestion: number
  datasetName: string
  status: OptimizationProcessStatus
  createdAt: Date
  planningStart: Date
  planningEnd: Date
  ducts: number
  dailySetupRowsMax: number
  dailyRefillingsMax: number
  rotationThresholdRows: number
  // KPI from_empty: null on from_last_config runs
  totalNumberRefillment: number | null
  totalAutomationDegree: number | null
  // KPI from_last_config (delta vs current config): null on from_empty runs.
  // Signed values, shown as-is. Positive delta automation is good; negative
  // delta refill is good. Percentages already ×100. Absolutes already integers.
  deltaAutomationAbs: number | null
  deltaAutomationPct: number | null
  // Delta automation expressed as percentage points on the total (already ×100).
  deltaAutomationOnTotalPct: number | null
  // Automation share before/after the delta, as a percentage (already ×100).
  automationShareBeforePct: number | null
  automationShareAfterPct: number | null
  deltaRefillAbs: number | null
  deltaRefillPct: number | null
  // from_last_config launch inputs (minutes) and the KPI they produce:
  // minutes per day saved by every suggested swap. null when the inputs
  // were cleared, on from_empty runs, or before the run completes.
  minutesSavedPerOrderLine: number | null
  minutesSavedPerRefill: number | null
  timeSavedMinutes: number | null
  startedAt?: Date
  stoppedAt?: Date
  scenario: string
  pipelineType: PipelineType
}

export type OptimizationProcesses = Results<OptimizationProcess>

export const isCreated = (
  status: OptimizationProcessStatus
): status is typeof CREATED => status === CREATED

export const isStarted = (
  status: OptimizationProcessStatus
): status is typeof STARTED => status === STARTED

export const isRunning = (
  status: OptimizationProcessStatus
): status is typeof RUNNING => status === RUNNING

export const isDone = (
  status: OptimizationProcessStatus
): status is typeof DONE => status === DONE

export const isAborted = (
  status: OptimizationProcessStatus
): status is typeof ABORTED => status === ABORTED

export const isFailed = (
  status: OptimizationProcessStatus
): status is typeof FAILED => status === FAILED
